<template>
    <div class="login-form">
        <form
            class="grid"
            novalidate
            @submit.prevent="submit">
            <slot name="intro"></slot>
            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="LoginUsername">{{ usernamePlaceholder }}</label>
                    <input
                        autocomplete="username"
                        autofocus
                        data-e2e="login-form.account-id"
                        id="LoginUsername"
                        name="LoginUsername"
                        type="text"
                        v-model.trim="username"
                        v-validate.disable="usernameValidationRules"
                        :aria-label="usernamePlaceholder"
                        :class="{ 'input--invalid': errors.has('LoginUsername') }"
                        :placeholder="usernamePlaceholder">
                    <span
                        class="error-message"
                        v-if="errors.has('LoginUsername')">{{ errors.first('LoginUsername') }}</span>
                </div>
            </div>
            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="LoginPassword">Password</label>
                    <input
                        aria-label="Password"
                        autocomplete="current-password"
                        data-e2e="login-form.password-field"
                        id="LoginPassword"
                        name="LoginPassword"
                        placeholder="Password"
                        type="password"
                        v-model.trim="password"
                        v-validate.disable="'required'"
                        :class="{ 'input--invalid': errors.has('LoginPassword') }">
                    <span
                        class="error-message"
                        v-if="errors.has('LoginPassword')">{{ errors.first('LoginPassword') }}</span>
                </div>
            </div>
            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <button
                        class="submit"
                        type="submit"
                        :disabled="isAwaitingResponse">Login</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    created () {
        this.username = this.usernameInitialValue || this.username
    },
    data () {
        return {
            isAwaitingResponse: false,
            password: '',
            username: ''
        }
    },
    methods: {
        submit () {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) { return Promise.resolve(null) }

                    this.isAwaitingResponse = true
                    return this.onValidSubmit(this.username, this.password)
                })
                .finally(() => {
                    this.isAwaitingResponse = false
                })
        }
    },
    props: {
        onValidSubmit: {
            required: true,
            type: Function
        },
        usernameInitialValue: {
            default: '',
            required: false,
            type: String
        },
        usernamePlaceholder: {
            default: 'Username',
            required: false,
            type: String
        },
        usernameValidationRules: {
            default: 'required',
            required: false,
            type: String
        }
    }
}
</script>
